import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Api from "../../openapi";
import { RootState } from "../../store";
import { IUser } from "../../store/userSlice";
import { UserDetailResponse } from "../../openapi/client";
import { checkEmptyObj, cachedApiCall } from "../../utils";
import { setUserDetail as setUserDetailAction } from "../../store/userDetail";
import { cleanSession } from "../../utils/tokenStore";

export default function useUser() {
  const dispatch = useDispatch();
  const userStore = useSelector((state: RootState) => state.user);
  const [user, setUser] = useState<IUser>(userStore);
  const [userDetail, setUserDetail] = useState<UserDetailResponse>();

  const getUser = async () => {
    try {
      if (!checkEmptyObj(user)) {
        return user;
      }

      // Use cached API call to prevent duplicate requests
      const userInfo = await cachedApiCall(
        "user_getUser",
        async () => {
          const req = await Api.User.getUser();
          return req.data;
        },
        60000 // 60 second cache
      );

      setUser(userInfo as IUser);
      return userInfo;
    } catch (error: any) {
      if (error?.response?.status === 401) {
        cleanSession();
      }
      console.error("getUser failed:", error);
    }
  };

  const getUserDetail = async () => {
    try {
      // Use cached API call to prevent duplicate requests
      const userDetailInfo = await cachedApiCall(
        "user_getUserDetail",
        async () => {
          const req = await Api.User.getUserDetail();
          return req.data;
        },
        30000 // 30 second cache
      );

      setUserDetail(userDetailInfo);
      dispatch(setUserDetailAction(userDetailInfo));
      return userDetailInfo;
    } catch (error: any) {
      if (error?.response?.status === 401) {
        cleanSession();
        return;
      }
      console.error("getUserDetail failed:", error);
    }
  };

  return { getUser, getUserDetail };
}
